const Rightside = ()=> {
    return (
        <div id="rightside" className="w-full h-full flex flex-col items-center justify-end gap-6 text-lightestslate">


            <a href="mailto:saicharan6118@gmail.com" className="hover:text-green">
                <p className="text-sm rotate-90 w-72 tracking-wide text-lightest-slate">
                    saicharan6118@gmail.com
                </p>
            </a>
            <span className="w-[2px] h-32 bg-slate inline-flex">
        </span>
        
        </div>
    )
}

export default Rightside;